<section class="casto-card">
  <header class="header">
    <span class="casto-title large" [innerHTML]="'tunnel.purchase-list.cart-title' | translate"></span>
    <div class="total">
      <span class="casto-title" [innerHTML]="'tunnel.purchase-list.sub-total' | translate"></span>
      @if (displayDiscount()) {
        <span class="casto-title casto-discount">
          {{ tunnelCartService.total() | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
        </span>
      }
      <span class="casto-title blue">
        {{ tunnelCartService.totalWithDiscount() | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
      </span>
    </div>
  </header>

  <div class="content">
    <ng-casto-tunnel-cart-list [lines]="tunnelCartService.lines()"></ng-casto-tunnel-cart-list>
  </div>
</section>
